import { post, postpro, putGeneral } from '../index';



export const createPost = data => {
  return post('/posts', data, false);
};

export const updatePostBack = data => {
  return putGeneral(`/posts?id=${data._id}`, data, false);
};

export const createPostNew = data => {
  return postpro('/posts', data, false);
};
